import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { WindowService } from '../../../services/window-dialogs/window.service';
import { SortBot } from '../../../helpers/sort';
import { MobileFilesItemArray } from '../../../models/domain/mobile.files.item';
import { WindowSettings } from '../../../services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../services/window-dialogs/window.event';
import { FileUploadItemArray } from '../../../models/domain/file.upload.item';

@Component({
    selector: 'member-files',
    templateUrl: './member.files.component.html',
    styleUrls: ['./member.files.component.css']
})

export class MemberFilesComponent implements OnInit, OnDestroy {
    @Input('IsBusy') IsBusy: boolean = false;
    @Input('YardFiles') YardFiles: MobileFilesItemArray;
    @Input('UploadedFiles') UploadedFiles: FileUploadItemArray;
    @Input('UploadedLogs') UploadedLogs: FileUploadItemArray;

    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    YardFilesSearch: String;

    yardFilesResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    uploadedFilesResultRows: number = 25;
    uploadedFilesFirstResult: number = 0;
    uploadedFilesLastResult: number = 24;

    uploadedLogsResultRows: number = 25;
    uploadedLogsFirstResult: number = 0;
    uploadedLogsLastResult: number = 24;

    constructor(private windowService: WindowService) {}

    SortByCreatedDate() { this.YardFiles = SortBot.SortAuto(this.YardFiles, 'CreatedDate'); }
    SortByFileName() { this.YardFiles = SortBot.SortAuto(this.YardFiles, 'FileName'); }
    SortByTitle() { this.YardFiles = SortBot.SortAuto(this.YardFiles, 'Title'); }
    SortByDeviceID() { this.YardFiles = SortBot.SortAuto(this.YardFiles, 'DeviceID'); }
    SortByLicenseKey() { this.YardFiles = SortBot.SortAuto(this.YardFiles, 'LicenseKey'); }

    SortUploadedFilesBy(sortVar1: string, sortVar2: string = '') { this.UploadedFiles = SortBot.SortAuto(this.UploadedFiles, sortVar1, sortVar2); }
 
    SortUploadedLogsBy(sortVar1: string, sortVar2: string = '') { this.UploadedLogs = SortBot.SortAuto(this.UploadedLogs, sortVar1, sortVar2); }


    ngOnInit() {

    }

    ngOnDestroy() {

    }

    paginateYardFiles(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    paginateUploadedFiles(e) {
        this.uploadedFilesFirstResult = e.page * e.rows;
        this.uploadedFilesLastResult = this.uploadedFilesFirstResult + e.rows;
    }

    paginateUploadedLogs(e) {
        this.uploadedLogsFirstResult = e.page * e.rows;
        this.uploadedLogsLastResult = this.uploadedLogsFirstResult + e.rows;
    }

    onLicenseClick(key: string) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<string>(WindowTypes.License, key, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                subscription.unsubscribe();
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });

    }

    ReloadFiles() {
        this.onRefresh.emit('');
    }

}
